import { gtagTrack } from 'src/helpers/pixel'

export const useGtag = () => {
  const gtagTrackViewContentSignupStep1 = () => {
    gtagTrack('view_item', { event_label: 'register_step1' })
  }

  const gtagTrackViewContentSignupStep2 = () => {
    gtagTrack('view_item', { event_label: 'register_step2' })
  }
  const gtagTrackSubmitApplication = () => {
    gtagTrack('sign_up')
    gtagTrack('conversion', { send_to: 'AW-10796388146/AVikCNWp1P4CELKej5wo' })
  }

  return {
    gtagTrackViewContentSignupStep1,
    gtagTrackViewContentSignupStep2,
    gtagTrackSubmitApplication
  }
}
